import "bootstrap-sass";
import "./modules/jquery-match-height";
import "./modules/collapse-more";
// import "./modules/placeholder";
import "./modules/fix-button";
import "./modules/privacy";

// import "./modules/webfont";
// import "./modules/page-top";
// import "./modules/jqueryvalidation";
// import { menuTrigger } from "./modules/menu-trigger";
// import "./modules/bs.tab";
// import "./modules/js-header";
// import "./modules/js-footer";
// import "./modules/waypoints";
// import "./modules/dropdown-hover";
// import "./modules/swiper";
// import "./modules/gdpr-banner";
// import "./modules/gdpr-global-banner";
// import "./modules/toBoolean";
// import "./modules/barba";
// import "./modules/tracking";
// import "./modules/modal-load";
// import "./modules/sticky-sidebar";
